import { GetFieldForFilterAndSort } from '../Util/Field';

const FormTemplateCollectionFields = [
	GetFieldForFilterAndSort(
		"Meta_date_str256[CreatedOn].string",
		"Created On",
		"FieldType_Date",
	),
	GetFieldForFilterAndSort(
		"Meta_text_kw256lc[Name].keyword",
		"Name",
		"FieldType_Text",
		"Meta_text_kw256lc[Name]",
	),
	GetFieldForFilterAndSort(
		"Meta_int[PageCount]",
		"Page Count",
		"FieldType_Number",
	),
];

export default FormTemplateCollectionFields;